export default __webpack_public_path__ + "b927a15ac568898e4b40083578834d66.png";